import { ChevronDown, Percent, Plus, Ticket, X } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

import CupomForm from "./CupomForm";
import DescontoManual from "./DescontoManual";
import { brl } from "../lib/formato";

function Escolha({ onEscolher }) {
  const opcoes = [
    { modo: "manual", icone: Percent, titulo: "Desconto", sub: "% ou R$ fixo" },
    { modo: "coupon", icone: Ticket, titulo: "Cupom", sub: "código" },
  ];
  return (
    <div className="grid grid-cols-2 gap-2">
      {opcoes.map(({ modo, icone: Icone, titulo, sub }) => (
        <button
          key={modo}
          type="button"
          onClick={() => onEscolher(modo)}
          className="p-2.5 rounded-lg border-2 border-border bg-card hover:border-orange-500 hover:bg-orange-500/5 flex flex-col items-center gap-1 transition-all"
        >
          <Icone className="w-4 h-4 text-orange-500" />
          <p className="text-[11px] font-bold">{titulo}</p>
          <p className="text-[9px] text-muted-foreground">{sub}</p>
        </button>
      ))}
    </div>
  );
}

function DescontoAplicado({ desconto }) {
  const { tipo, valor, cupom, montante, onRemover } = desconto;
  let rotulo = `Cupom ${cupom?.code || ""}`;
  if (tipo === "percent") rotulo = `Desconto ${valor}%`;
  else if (tipo === "fixed") rotulo = "Desconto";
  return (
    <div className="flex justify-between items-center text-sm bg-green-500/10 border border-green-500/30 rounded-lg px-3 py-2">
      <span className="flex items-center gap-1.5 text-green-700 dark:text-green-400 font-semibold">
        <Ticket className="w-3.5 h-3.5" />
        {rotulo}
        <button type="button" onClick={onRemover} className="text-muted-foreground hover:text-red-500" title="Remover desconto">
          <X className="w-3.5 h-3.5" />
        </button>
      </span>
      <span className="font-bold text-green-700 dark:text-green-400">- {brl(montante)}</span>
    </div>
  );
}

// Espelha o fluxo do Delivery > Novo Pedido. Vale sobre o que está sendo pago
// na rodada, não sobre a mesa inteira.
export default function DescontoCupom({ desconto, subtotal }) {
  const [aberto, setAberto] = useState(false);
  const [modo, setModo] = useState(null);

  if (desconto.tipo !== "none") return <DescontoAplicado desconto={desconto} />;
  if (!(subtotal > 0)) return null;

  const aplicar = (dados, msg) => {
    desconto.onAplicar(dados);
    setAberto(false);
    setModo(null);
    toast.success(msg);
  };

  return (
    <>
      <button
        type="button"
        onClick={() => setAberto((v) => !v)}
        className="w-full flex items-center justify-between text-sm text-orange-600 dark:text-orange-400 hover:bg-orange-500/10 border border-dashed border-orange-500/30 rounded-lg py-3 px-4 transition-colors"
      >
        <span className="flex items-center gap-1.5 font-semibold"><Ticket className="w-3.5 h-3.5" /> Aplicar desconto ou cupom</span>
        {aberto ? <ChevronDown className="w-3.5 h-3.5" /> : <Plus className="w-3.5 h-3.5" />}
      </button>
      {aberto && (
        <div className="bg-muted/40 border border-border rounded-lg p-2.5 space-y-2.5">
          {!modo && <Escolha onEscolher={setModo} />}
          {modo === "manual" && (
            <DescontoManual subtotal={subtotal} onVoltar={() => setModo(null)} onAplicar={(d) => aplicar(d, "Desconto aplicado")} />
          )}
          {modo === "coupon" && (
            <CupomForm
              subtotal={subtotal}
              clienteId={desconto.clienteId}
              clienteTelefone={desconto.clienteTelefone}
              itens={desconto.itens}
              modulo={desconto.modulo}
              onVoltar={() => setModo(null)}
              onAplicar={(cupom) => aplicar({ tipo: "coupon", valor: 0, cupom }, `Cupom ${cupom.code} aplicado!${cupom.note ? ` ${cupom.note}` : ""}`)}
            />
          )}
        </div>
      )}
    </>
  );
}
